import routes from "@/lib/routes";

const RETURN_TO_PARAM = "return_to";
const PLACEHOLDER_ORIGIN = "http://return-to.invalid";
const HIRE_PATH =
  /^\/(district|school|principal|dashboards?|data|internal|getting-started|prospectlist|prospectentry|talent-marketplace|hiring-requests|createscorecard|editscorecard|view-scorecard|createreference|editreference|profile)([/?#]|$)/;

export const appendQuery = (path: string, query: string): string => {
  if (!query) return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}${query}`;
};

const isSameOriginPath = (path: string) =>
  path.startsWith("/") &&
  new URL(path, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN;

export const getHireReturnTo = (
  searchParams: URLSearchParams,
  fallback = routes.getAtsAdminDashboard(),
): string => {
  const returnTo = searchParams.get(RETURN_TO_PARAM);
  if (!returnTo || !isSameOriginPath(returnTo)) {
    return fallback;
  }

  const deepLinkParams = new URLSearchParams(searchParams);
  deepLinkParams.delete(RETURN_TO_PARAM);
  return appendQuery(returnTo, deepLinkParams.toString());
};

export const isHireReturnTo = (searchParams: URLSearchParams): boolean =>
  HIRE_PATH.test(getHireReturnTo(searchParams, ""));
